import React from "react";
import { Button, Space, Row, Col, Input, Tooltip, Image, Select } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";
import PaymentStore from "../store/PaymentStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import CompanyStore from "../store/CompanyStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";

const { Option } = Select;

class PaymentList extends React.Component {
  constructor(props) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.paymentStore = new PaymentStore();
    this.companyStore = new CompanyStore();
    this.companyRef = React.createRef();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      showDetails: false,
      companyId: "",
      companyVal_Lab: "",
      loadList: 0,
      searchField: "",
      paymentType: 0,
    };

    // this.query = new URLSearchParams(this.props.location.search)
    // this.queryId = this.query.get("oo")

    // console.log(this.queryId,this.query)
  }

  async componentDidUpdate(prevProps, prevState) {
    if (Number(this.props.getUserData().isadmin) === 1 || Number(this.props.getUserData().isadmin) === 0) {
      // console.log('innnnnn');
      this.props.navigate("/login");

    }
  }
  async componentDidMount() {

    // this.handleSearch();
    // console.log(this.context.viewStateStore.value, "vale");

    // const setPayment =
    //   this.context.viewStateStore.paymentObject;
    // if (setPayment.companyId !== "") {
    //   console.log(setPayment);
    //   await this.paymentStore.loadData({
    //     offset: (this.state.currentPage - 1) * this.state.pageSize,
    //     limit: this.state.pageSize,
    //     companyId: setPayment.companyId,
    //   });

    //   const singleData = await this.companyStore.getCompanyDataById(
    //     setPayment.companyId
    //   );

    //   await this.setState({ loadList: 1 });
    //   console.log("singleData", singleData);
    //   await this.setState({
    //     companyVal_Lab: singleData,
    //     companyId: setPayment.companyId,
    //   });
    //   console.log("singleData", singleData);
    // }


    // await this.paymentStore.loadData({ offset: 0, limit: 50 });

    this.setState({ pageSize: 50 });

    this.columns = [
      {
        // title: "Account Name",
        title: this.context.translate("_FLEET_COMPANY_COMPANYLIST_COMPANYNAME_"),
        dataIndex: "name",
        width: "15%",
      },
      {
        // title: "Payment Id",
        title: this.context.translate("_PAYMENT_ID_"),
        dataIndex: "paymentId",
        width: "15%",
      },
      {
        // title: "Payment Id",
        title: this.context.translate("_PAYMENT_TYPE_"),
        dataIndex: "paymentType",
        width: "15%",
      },
      {
        // title: "Payment Method",
        title: this.context.translate("_PAYMENT_METHOD_"),
        dataIndex: "type",
        width: "15%",
      },
      {
        // title: "Total Vehicle",
        title: this.context.translate("_TOTAL_VEHICLE_"),
        dataIndex: "count",
        width: "15%",
      },
      {
        // title: "Total Amount",
        title: this.context.translate("_TOTAL_AMOUNT_"),
        dataIndex: "amount",
        width: "15%",


      },
      {
        // title: "Payment Date",
        title: this.context.translate("_PAYMENT_DATE_"),
        dataIndex: "created_at",
        width: "15%",
      },

      {
        // title: "Details",
        title: this.context.translate("_PAYMENT_DATE_"),
        dataIndex: "finishedAt",
        width: "15%",
        render: (value, record) => {
          return (
            <Link
              to={`/vehiclepaymentlist/${record.companyId}/${record.Id}`}
              // to={`/vehiclepaymentlist/${record.companyId}`}
            >
              <Button
                onClick={async () => {
                  this.setState({ showDetails: true });
                  this.context.viewStateStore.setPaymentStates({ companyId: record.companyId, paymentId: record.Id })
                }}
              >
                {this.context.translate("_DETAILS_")}
              </Button>
            </Link>
          );
        },
      },
    ];



    if (Number(this.props.getUserData().isadmin) !== -1) {
      // console.log(this.props.getUserData().userCompanyId)
      await this.setState({ companyId: this.props.getUserData().userCompanyId })
      await this.setState({ userId: this.props.getUserData().userId })
      await this.handleSearch();
    }
    else {
      this.handleSearch();
      // console.log(this.context.viewStateStore.value, "vale");

      const setPayment =
        this.context.viewStateStore.paymentObject;
      if (setPayment.companyId !== "") {
        // console.log(setPayment);
        await this.paymentStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: setPayment.companyId,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setPayment.companyId
        );

        await this.setState({ loadList: 1 });
        // console.log("singleData", singleData);
        await this.setState({
          companyVal_Lab: singleData,
          companyId: setPayment.companyId,
        });
        // console.log("singleData", singleData);
      }


    }
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination, "pagi");
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleSearch() {
    await this.paymentStore.loadData({
      companyId: this.state.companyId,
      offset: this.state.currentPage - 1,
      limit: this.state.pageSize,
      paymentType: this.state.paymentType,
    });
    await this.setState({ loading: true, loadList: 1 });
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData });
    // await this.setState({ currentPage: 1, companyId: comp.value });
    await this.handleSearch();
  }

  searchInput = async (e) => {
    const value = e.target.value;

    if (value.length > 3) {
      await this.paymentStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        searchField: value,
      });

      await this.setState({ loadList: 1 });
    } else if (value.length === 0) {
      await this.paymentStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
      });
      await this.setState({ currentPage: 1 });
    }
  };

  // refreshList = async () => {
  //   this.setState({ loading: true });
  //   if (this.state.companyId) {
  //     await this.paymentStore.loadData({
  //       companyId: this.state.companyId,
  //       offset: 0,
  //       limit: 50,
  //     });
  //   }
  //   this.setState({ loading: false, currentPage: 1 });
  // };

  handleClear = async () => {
    await this.setState({
      companyVal_Lab: null,
      companyId: "",
      searchField: "",
    });
    this.handleSearch();
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  ref={this.companyRef}
                  onChange={(comp) => this.handleChange(comp)}
                  value={
                    this.state.companyVal_Lab
                      ? this.state.companyVal_Lab
                      : null
                  }
                  allowClear
                  onClear={this.handleClear}
                  style={{ width: 165 }}
                  fromAccountList={1}
                />

                <Select
                  defaultValue={0}
                  style={{ width: 100 }}
                  onSelect={async (value) => {
                      this.setState(
                        { paymentType: value, loadList: 1 },
                        () => {
                          this.handleSearch();
                        }
                      );
                  }}
                  placeholder="Payment Type"
                  className="searchInput"
                >
                  <Select.Option value={0}> {this.context.translate("_ALL_")}</Select.Option>
                  <Select.Option value={1}> {this.context.translate("_TABBY_")}</Select.Option>
                  <Select.Option value={2}> {this.context.translate("_MOYASAR_")}</Select.Option>
                </Select>

                {this.props.getUserData().isadmin != 0 && (
                  <Input
                    className="searchInput"
                    placeholder={this.context.translate(
                      "_SEARCH_BY_NAME_MOBILE_EMAIL_"
                    )}
                    value={this.state.searchField}
                    style={{ width: 400, borderRadius: "25px" }}
                    onChange={async (e) => {
                      await this.setState({ searchField: e.target.value });
                      await this.searchInput(e);
                    }}
                  />
                )}
              </Space>
            </Col>
            {/* <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => {
                      this.refreshList();
                      this.setState({
                        searchField: "",
                      });
                    }}
                  ></Image>
                </Tooltip>

                <Tooltip
                  title={this.context.translate("_DOWNLOAD_")}
                  placement="bottom"
                >
                  <span>
                    <Button
                      className="downloadExcelButton"
                      disabled={
                        this.paymentStore?.payment?.length > 0 ? false : true
                      }
                      onClick={(val) => {
                        // Add export functionality here if needed
                        console.log("Download clicked");
                      }}
                    >
                      <Image
                        style={{
                          height: 18,
                          width: "auto",
                        }}
                        src={downloadIcon}
                      />
                    </Button>
                  </span>
                </Tooltip>
              </Space>
            </Col> */}
          </Row>

          <ListTable
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.paymentStore?.total}
            columns={this.columns}
            dataSource={this.paymentStore?.payment}
            loading={this.paymentStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>
      </>
    );
  }
}
PaymentList.contextType = StoreContext;
export default observer(withRouter(PaymentList));
